// extracted by mini-css-extract-plugin
export var editButton = "detailsPage-module--edit-button--44328";
export var pageAdditionalInfos = "detailsPage-module--page-additional-infos--3bb8e";
export var pageBody = "detailsPage-module--page-body--ddd78";
export var pageFooter = "detailsPage-module--page-footer--80c55";
export var pageFooterBack = "detailsPage-module--page-footer-back--6375a";
export var pageIntro = "detailsPage-module--page-intro--50992";
export var pageIntroContainer = "detailsPage-module--page-intro-container--3a44d";
export var pageIntroImg = "detailsPage-module--page-intro-img--abafb";
export var pageIntroTitle = "detailsPage-module--page-intro-title--891b5";
export var pageSummary = "detailsPage-module--page-summary--b19ee";
export var pageTags = "detailsPage-module--page-tags--89b6f";
export var pageTaxo = "detailsPage-module--page-taxo--d6d43";